import { UDButton, UDText } from 'ud-ui/components';

import classNames from 'classnames';
import { theme } from 'styles/theme/theme';
import { DropZoneBodyProps } from '../types';

interface Props extends DropZoneBodyProps {
  className?: string;
}

function BodyDropzone(props: Props) {
  const { title = 'Перетащите сюда изображения', subtitle = 'или', buttonText = 'Выберите файл', onButtonClick, className } = props;

  return (
    <div className={classNames('flex-center flex-column gap-2', className)}>
      <UDText type="subhead">{title}</UDText>
      {subtitle && (
        <UDText type="subhead" color={theme.colors.SurfaceRomanSilver30}>
          {subtitle}
        </UDText>
      )}
      <UDButton variant="secondary" onClick={onButtonClick}>
        {buttonText}
      </UDButton>
    </div>
  );
}

export default BodyDropzone;
